import { createElement, useEffect, useRef, useState } from 'react';
import './index.scss';
const DCSlider = ({ speed = 500, autoplay, loop, picUrls = [], height, delay, ...otherProps }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const autoplayRef = useRef(null);
    const nextSlide = () => {
        if (currentIndex < picUrls.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
        else if (loop) {
            setCurrentIndex(0);
        }
        else {
            stopAutoplay();
        }
    };
    const startAutoplay = () => {
        if (autoplay && !autoplayRef.current) {
            autoplayRef.current = setInterval(() => {
                nextSlide();
            }, delay);
        }
    };
    const stopAutoplay = () => {
        if (autoplayRef.current) {
            clearInterval(autoplayRef.current);
            autoplayRef.current = null;
        }
    };
    useEffect(() => {
        startAutoplay();
        return () => stopAutoplay();
    }, [autoplay, currentIndex]);
    return (createElement("div", { className: "carousel", style: { height: height ? `${height}px` : 'auto' }, ...otherProps },
        createElement("div", { className: "carousel__wrapper", style: {
                transform: `translateX(-${currentIndex * 100}%)`,
                transitionDuration: `${speed}ms`,
            } }, picUrls.map((url, index) => (createElement("div", { key: index, className: "carousel__slide" },
            createElement("img", { src: url, alt: `Slide ${index}`, style: { height: height ? `${height}px` : '100%' } })))))));
};
export default DCSlider;
